import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "title-page" }



interface Props {
    text: String
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTitle',
  props: {
    text: null
  },
  setup(__props: any) {

const props = __props as {
    text: String
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.text), 1)
  ]))
}
}

})